<agr-page-detail
  [pageTitle]="(pageTitle$ | async) + ' (' + ('locationExternalId' | translate) + ' ' + (location$ | async)?.externalId + ')'"
  [isEmpty]="!orderableFertilisersTableConfig?.dataSource?.data?.length && !nonOrderableFertilisersTableConfig?.dataSource?.data?.length"
  [emptyTitle]="'noTreatments' | translate"
  [emptyDescription]="'noTreatmentsInAdvice' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="print"
  [primaryActionText]="'orderTexts.orderReceiptReport' | translate"
  (primaryAction)="print()"
  (backAction)="back()"
>
  <agr-print-page
    [footerText]="'fertilisersReportWarningFooter' | translate"
    [relatedPeople]="relatedPeople$ | async"
    [marginLeft]="true"
    [showPageNumber]="false"
  >
    <div class="spacing--padding-bottom">
      <app-general-info [reportForLabel]="'report.forLabel'"></app-general-info>
    </div>

    @if (orderableFertilisersTableConfig?.dataSource?.data?.length) {
      <div class="avoid-page-break spacing--margin-half-vertical">
        <h2 class="text--h3 layout--margin-horizontal">{{ 'fertilisers-overview.table.orderableProductsTitle' | translate }}</h2>
        <agr-table [config]="orderableFertilisersTableConfig" data-test="orderableReceiptTable"></agr-table>
      </div>
    }
    @if (nonOrderableFertilisersTableConfig?.dataSource?.data?.length) {
      <div class="avoid-page-break spacing--margin-half-vertical">
        <h2 class="text--h3 layout--margin-horizontal">{{ 'fertilisers-overview.table.nonOrderableProductsTitle' | translate }}</h2>
        <agr-table [config]="nonOrderableFertilisersTableConfig" data-test="nonOrderableReceiptTable"></agr-table>
      </div>
    }
    @if (proprietaryFertilisersTableConfig?.dataSource?.data?.length) {
      <div class="avoid-page-break spacing--margin-half-vertical">
        <h2 class="text--h3 layout--margin-horizontal">{{ 'fertilisers-overview.table.proprietaryFertilizers' | translate }}</h2>
        <agr-table [config]="proprietaryFertilisersTableConfig" data-test="proprietaryFertilisersReceiptTable"></agr-table>
      </div>
    }
  </agr-print-page>
</agr-page-detail>
